<app-overlay-pop-up
  [openOnHover]="!openOnClick"
  [isDisabled]="disabled"
  [overlayContentClass]="overlayContentClass"
  [blockRepositioning]="blockRepositioning">
  <!-- Trigger Content -->
  <div
    overlay-trigger
    class="{{outerClass}}"
    [ngClass]="(!withArrow && !disabled) ? 'hover-without-arrow' : ''"
    [class.clickable]="!disabled">
    @if (title) {
      <div class="flex flex-row items-center justify-start">
        <label class="input-title">{{title}}</label>
        @if (isRequired) {
          <span class="red-10 line-height-80">*</span>
        }
      </div>
    }

    <div class="control" [class.disabled]="disabled">
      <div
        data-qa="app-selector-selected-item"
        class="flex flex-row items-center justify-center control-text">
        @if (field && selectedItem?.iconNameAndStylingLeft) {
          <app-all-icons [iconNameAndStyling]="selectedItem.iconNameAndStylingLeft"/>
        }
        @if (selectedItemStyle) {
          <span class="pr-[0.5rem] {{selectedItemStyle?.class}}">{{selectedItemStyle.text}}</span>
        }
        @let text = (selectedItem ? (isSimpleArray ? selectedItem : (selectedItem[field] ? selectedItem[field] : selectedOption)) : selectedOption);
        <span
          class="control-text {{textClass}}"
          id="{{SELECTED_ITEM_ID}}"
          (mouseenter)="activateSelectedItemTooltip(text)"
          (mouseleave)="toolTipSettings.show = false">
          {{text | linkShort : maxLengthSelectedItem}}
        </span>
      </div>
      <div class="flex flex-row items-center justify-center gap-[0.25rem]">
        @if (field && selectedItem?.iconNameAndStyling1) {
          <app-all-icons [iconNameAndStyling]="selectedItem.iconNameAndStyling1"/>
        }
        @if (field && selectedItem?.iconNameAndStyling2) {
          <app-all-icons
            [iconNameAndStyling]="selectedItem.iconNameAndStyling2"/>
        }
        @if (itemTextField && selectedItem && selectedItem[itemTextField]) {
          <span
            class="min-w-[10rem] main-8 {{selectedItemStyle?.class}}">
            {{selectedItem[itemTextField] | titlecase}}
          </span>
        }
        @if (withArrow) {
          <div class="suffix">
            <app-all-icons [iconNameAndStyling]="'arrow-down.svg; icon-main-size'"/>
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Overlay Content -->
  <div overlay-content>
    <div>
      <div class="overlay-dropdown">
        @if (Array.of(dataKeys)?.length) {
        <div class="overlay-list">
          <div class="list-block">
            @if (checkBoxField) {
              <div class="list-entry flex flex-row justify-between items-center border-bottom br-0">
                <app-checkbox
                  data-qa="selector-checkbox-option"
                  [checked]="checkBoxField.status"
                  (change)="checkBoxField.status = !checkBoxField.status;
                    checkBoxFieldClick(checkBoxField.status)">
                </app-checkbox>
                <span class="text-left">{{checkBoxField.title}}</span>
              </div>
            }
            @if (buttonField) {
              <div class="list-entry flex flex-row justify-between items-center border-bottom br-0">
                <app-button
                  data-qa="selector-button-option"
                  [type]="buttonField.type"
                  [size]="buttonField.size"
                  [iconName]="buttonField.iconName"
                  (buttonClick)="buttonClick.emit()">
                  {{buttonField.text}}
                </app-button>
              </div>
            }
            @for (item of dataKeys; track item; let i = $index) {
              <div
                data-qa="app-selector-list-entry"
                class="list-entry {{listEntryAdditionalClass}} flex flex-row justify-between items-center"
                [class.not-in-table]="isNotInTable"
                [ngClass]="{
                  'h-[1.5rem]': roundDates && roundDates[i],
                  'no-propagation opacity0p5': item.disabled
                }"
                [appScrollIntoView]="(isSimpleArray ? item : item[field]) === scrollIntoValue"
                [class.bg-black-2]="(selectedItem) && (selectedItem === item || (field && selectedItem[field] === item[field]))"
                (click)="onItemSelect(item)">
                @if (field && item.iconNameAndStylingLeft) {
                  <app-all-icons
                    class="pr-[0.5rem]"
                    [iconNameAndStyling]="item.iconNameAndStylingLeft"
                  />
                }
                <div class="flex flex-row justify-between items-center w-[100%]">
                  <div class="flex flex-col justify-end">
                    <app-text-with-tooltip
                      [attr.data-qa]="'selector-item-' + i"
                      [id]="LIST_ITEM_ID + i"
                      [text]="isSimpleArray ? item : item[field]">
                    </app-text-with-tooltip>
                    @if (roundDates) {
                      <span class="font-4 opacity0p64 bold500">{{roundDates[i]}}</span>
                    }
                  </div>
                  <div class="flex flex-row items-center justify-center gap-[0.25rem]">
                    @if (field && item.iconNameAndStyling1) {
                      <app-all-icons [iconNameAndStyling]="item.iconNameAndStyling1"/>
                    }
                    @if (field && item.iconNameAndStyling2) {
                      <app-all-icons [iconNameAndStyling]="item.iconNameAndStyling2"/>
                    }
                  </div>
                  @if (itemTextField && item[itemTextField]) {
                    <span class="main-8 {{selectedItemStyle?.class}}">
                        {{item[itemTextField] | titlecase}}
                    </span>
                  }
                </div>
              </div>
            }
          </div>
        </div>
        } @else {
          @if (buttonField) {
            <div class="list-entry flex flex-row items-center justify-center border-bottom br-0">
              <app-button
                data-qa="selector-button-empty-state"
                [type]="buttonField.type"
                [size]="buttonField.size"
                [iconName]="buttonField.iconName"
                (buttonClick)="buttonClick.emit()">
                {{buttonField.text}}
              </app-button>
            </div>
          }
          <div class="font-3 p-[0.5rem]">No result</div>
        }
      </div>
    </div>
  </div>
</app-overlay-pop-up>

@if (toolTipSettings.show) {
  <app-tooltip
    [coordinates]="toolTipSettings.coordinates"
    [title]="toolTipSettings.title">
  </app-tooltip>
}
